import { professionRealmMapping } from "../data/magicrealm";
import { calcLevel } from "../groups/group";
// | [ ] | Alle | Zauberlisten (Limitiert)       | Hat keine Gruppe und der Bonus pro Liste ist wie folgt: Progression   | `[0.1, 1, 0.5, 0]`|
export function calculateSpells(character) {
    return character.spellLists.map(s => {
        return Object.assign(Object.assign({}, s), { rank: calculateSpellList(s, character) });
    }).sort((a, b) => a.id > b.id ? 1 : -1);
}
function calculateSpellList(spellList, character) {
    return calcLevel(spellList.points, [0, 1, 1, 0.5, 0.5, 0])
        + getProfessionBonus(character.profession)
        + getRealmBonus(character);
}
function getProfessionBonus(profession) {
    const result = profession.bb.filter(m => m.name == "Kategorie Zauber");
    return result.length > 0
        ? result[0].levelCosts[0]
        : 0;
}
export function getRealmBonus(character) {
    const result = professionRealmMapping.filter(p => p.professionId == character.profession.id);
    if (result.length == 0)
        return 0;
    const attributes = result[0].attributes;
    if (attributes.length == 1)
        return character.characterAttributes[attributes[0]];
    return attributes
        .map(a => character.characterAttributes[a])
        .reduce((a, b) => a + b) / 2;
}
